export default __webpack_public_path__ + "static/media/bancontact-logo.9ee357d9.png";